import { render, staticRenderFns } from "./RegisterExpired.vue?vue&type=template&id=e2d30cb2&scoped=true"
import script from "./RegisterExpired.vue?vue&type=script&lang=js"
export * from "./RegisterExpired.vue?vue&type=script&lang=js"
import style0 from "./RegisterExpired.vue?vue&type=style&index=0&id=e2d30cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d30cb2",
  null
  
)

export default component.exports